import { UserCredentials } from './UserCredentials';
import { UserWithFunctions } from './UserWithFunctions';
export class EsAuthor {

  constructor(
    public id?: number,
    public firstname?: string,
    public lastname?: string,
    public email?: string,
    public profiles?: string[],
    public label?: string
  ) {
  }


  static getUserLabel(author: EsAuthor | UserCredentials, withPoint = false): string {
    let result = '';
    if (!!author) {
      if (!withPoint) {
        result = author?.firstname + ' ' + author?.lastname;
      } else {
        result = author?.firstname + '.' + author?.lastname;
      }
    }
    return result;
  }

  static getInitials(author: EsAuthor | UserCredentials) {
    return (author.firstname.charAt(0) + author.lastname.charAt(0)).toUpperCase();
  }

  static fromUserWithFunctions(userWithFunctions: UserWithFunctions) {
    return new EsAuthor(
      userWithFunctions.id,
      userWithFunctions.firstname,
      userWithFunctions.lastname,
      userWithFunctions.email,
      undefined
    );
  }
}
